import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

// Try to avoid npm run build remove something needed for dropdowns,
// so dropdowns should work wells also on prodution builds
import 'bootstrap';

import './index.scss';
//import 'antd/dist/antd.css';
import './i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AuthorizationProvider } from './authorization';
import constants from './constants';

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<div></div>}>
      <AuthorizationProvider authorizationProps={constants.keycloak}>
        <App />
      </AuthorizationProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
